import React from 'react';
import { Menu, Layout } from 'antd';
import { sessionManager } from '../../core/SessionManager';
import * as Icon from '@ant-design/icons'

const { SubMenu } = Menu;
const { Sider } = Layout;

export default function MenuNav(props) {

  let menuList = sessionManager.getMenuList() || [];

  const [openKeys, setOpenKeys] = React.useState([]);
  const [rootSubmenuKeys] = React.useState(menuList.map(item=> {return item.menuId.toString()}))

  const goTargetPage = (value) => {
    props.history.push(value.menuPath);
  }


  const onOpenChange = keys => {
    const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const getMenu = (value) => {
    if (value.children === null || value.children.length === 0) {
      return (
        <Menu.Item key={value.menuId} icon={React.createElement(Icon[value.menuIcon])} title={value.menuName} onClick={goTargetPage.bind(this, value)} >
          {value.menuName}
        </Menu.Item>
      )
    } else {
      return (
        <SubMenu key={value.menuId} icon={React.createElement(Icon[value.menuIcon])} title={value.menuName} >
          {value.children.map((subValue, subIndex) => {
            return <Menu.Item key={subValue.menuId} onClick={goTargetPage.bind(this, subValue)} >
              {subValue.menuName}
            </Menu.Item>
          })}
        </SubMenu>
      )
    }
  }

  return (
    <Sider style={{ backgroundColor: 'white' }} width={250} >
      <Menu
      style={{height:"100%"}}
        mode={'inline'}
        theme={'light'}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
      >
        {menuList.map((value) => {
          return getMenu(value)
        })}
      </Menu >
    </Sider>
  );
};

